import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';
import { colors, typography, spacing } from '../styles/theme';

const styles = StyleSheet.create({
  container: {
    marginBottom: spacing.md,
  },
  title: {
    ...typography.sectionTitle,
  },
  titleNoUnderline: {
    fontSize: 14,
    fontWeight: 'bold',
    color: colors.primary,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    marginBottom: spacing.sm,
  },
  subtitle: {
    ...typography.caption,
    marginTop: spacing.xs,
  },
  // Subsection variant
  subsectionTitle: {
    ...typography.subsection,
  },
});

const SectionTitle = ({
  title,
  subtitle,
  variant = 'default',
  showUnderline = true,
  style,
}) => {
  const isSubsection = variant === 'subsection';

  return (
    <View style={[styles.container, style]}>
      <Text
        style={
          isSubsection
            ? styles.subsectionTitle
            : showUnderline
              ? styles.title
              : styles.titleNoUnderline
        }
      >
        {title}
      </Text>
      {subtitle && <Text style={styles.subtitle}>{subtitle}</Text>}
    </View>
  );
};

export default SectionTitle;
